/*
 * NC Collection Grid — drawer de filtros (focus trap, Escape, scroll lock, restauración de foco) y orden.
 * Los filtros son los NATIVOS de Shopify: el formulario es un GET normal (funciona sin JS); el orden
 * conserva los filtros activos porque solo cambia sort_by en la URL actual.
 */
class NCCollectionGrid extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.drawer = this.querySelector('[data-nccg-drawer]');
    this.opener = null;
    this.closeTimer = 0;

    this.querySelectorAll('[data-nccg-open]').forEach((btn) => btn.addEventListener('click', () => this.open(btn)));
    this.querySelectorAll('[data-nccg-close]').forEach((btn) => btn.addEventListener('click', () => this.close()));

    if (this.drawer) {
      this.drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.close();
        } else if (event.key === 'Tab') {
          this.trap(event);
        }
      });
      const form = this.drawer.querySelector('[data-nccg-form]');
      if (form) {
        form.addEventListener('submit', () => {
          form.querySelectorAll('input[type="number"]').forEach((input) => {
            if (input.value === '') input.disabled = true;
          });
        });
      }
    }

    const sort = this.querySelector('[data-nccg-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  }

  open(trigger) {
    if (!this.drawer || !this.drawer.hidden) return;
    this.opener = trigger || document.activeElement;
    clearTimeout(this.closeTimer);
    this.drawer.hidden = false;
    void this.drawer.offsetWidth;
    this.drawer.classList.add('is-open');
    document.documentElement.classList.add('nccg-lock');
    this.querySelectorAll('[data-nccg-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    const first = this.drawer.querySelector('[data-nccg-close].nccg__x');
    if (first) first.focus({ preventScroll: true });
  }

  close() {
    if (!this.drawer || this.drawer.hidden) return;
    this.drawer.classList.remove('is-open');
    document.documentElement.classList.remove('nccg-lock');
    this.querySelectorAll('[data-nccg-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    const raw = getComputedStyle(this).getPropertyValue('--nc-motion-normal').trim();
    const ms = (raw.endsWith('ms') ? parseFloat(raw) : parseFloat(raw) * 1000) || 420;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      this.drawer.hidden = true;
    }, ms + 30);
    if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
  }

  trap(event) {
    const nodes = [...this.drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')].filter(
      (el) => el.offsetParent !== null
    );
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

if (!customElements.get('nc-collection-grid')) {
  customElements.define('nc-collection-grid', NCCollectionGrid);
}
